export interface ClientSwitchInfo {
  id: number;
  licenseId: string;
}

export const clientIdKey = 'clientId';
